const USD_QUOTE_DECIMALS = 6;

const powerOfTen = (exponent: number) => BigInt(`1${'0'.repeat(exponent)}`);

export const normalizeQuoteDecimals = (
  value: bigint,
  sourceDecimals: number,
  targetDecimals = USD_QUOTE_DECIMALS
) => {
  if (sourceDecimals === targetDecimals) return value;
  if (sourceDecimals > targetDecimals) {
    return value / powerOfTen(sourceDecimals - targetDecimals);
  }
  return value * powerOfTen(targetDecimals - sourceDecimals);
};

export { USD_QUOTE_DECIMALS };
